import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";

export const Wrapper = styling("div")((props) => ({
  backgroundColor: Color.backgroundGrey,

  // Let For You grow beyond the viewport so all content remains scrollable.
  minHeight: props.selectedTab === "for-you" ? "calc(100svh - 68px)" : "50svh",
  height: props.selectedTab === "for-you" ? "auto" : "100%",
  width: "100%",

  "@media (max-width: 1279px)": {
    minHeight:
      props.selectedTab === "for-you" ? "calc(100svh - 52px)" : "50svh",
  },

  "@media (max-width: 839px)": {
    minHeight:
      props.selectedTab === "for-you" ? "calc(100svh - 82px)" : "50svh",
  },

  "@media (max-width: 640px)": {
    minHeight:
      props.selectedTab === "for-you" ? "calc(100svh - 62px)" : "50svh",

    "@media (max-height: 700px)": {
      minHeight:
        props.selectedTab === "for-you" ? "calc(100svh - 14px)" : "50svh",
    },
  },
}));
